import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            position: 'relative',
            mx: 'auto',
            px: {base: remCalc(16), md: remCalc(24), xl: 0},
            maxWidth: {base: '100%', xl: remCalc(1400)},
            textAlign: 'center',
            gap: {base: remCalc(16), md: remCalc(24), lg: remCalc(40)},
        },
        textblock: {
            gap: {base: remCalc(16), lg: remCalc(24)},
        },
        heading: {},
        bodycopy: {
            textStyle: 'body-large',
        },
        medias: {
            gap: {base: remCalc(16), lg: remCalc(24)},
        },
        wideMedia: {
            w: '100%',
            maxW: {base: remCalc(343), md: remCalc(598), lg: remCalc(810), xl: remCalc(1400)},
        },
        halfMedia: {
            w: '100%',
            maxW: {base: remCalc(343), md: remCalc(290), lg: remCalc(393), xl: remCalc(688)},
        },
    },
}
